// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ic3c5","container__row":"styles_container__row__9uPeF","skeleton-animation":"styles_skeleton-animation__mv4Mr"};